<ng-container>
    <div [title]="attachment.real_name" style="width: 100%;overflow: hidden">
        <div class="media mt-2">
            <img style="height: 44px;width: 45px;border-radius: 8px;" class="align-self-start mr-3" src="{{location}}"
                 alt="Generic placeholder image">
            <div class="media-body">
                <h4 class="mt-0 mb-0" style="font-weight: bold;">{{attachment.real_name}}</h4>
                <div class="col-12 no-padding-left">
                    <label style="margin: 0 0 12px;
    font-weight: bold;
    color: #80808061;">{{attachment.size !== undefined ? attachment.size : '' }}</label>
                    <button (click)="remove(attachment)" *ngIf="removePermission" type="button" style="    font-size: 13px;
    background: none;
    color: red;
    border: none;
    padding-top: 0;
    font-weight: 700;
    " class="ml-1 btn-sm btn btn-primary">Izbriši
                    </button>
                    <button (click)="download(attachment)" *ngIf="!removePermission" type="button" style="    font-size: 13px;
    background: none;
    color: red;
    border: none;
    padding-top: 0;
    font-weight: 700;
    " class="ml-1 btn-sm btn btn-primary">Preuzmi
                    </button>
                </div>
            </div>
        </div>

    </div>

</ng-container>
